var map = {
	"./en/index.js": "k7Dv",
	"./zh/index.js": "gzyV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LAyY";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/langs index.js$
// module id = LAyY
// module chunks = 9